
export function convertKBtoMB(sizeKO) {
  const sizeMo = sizeKO / 1024;
  return sizeMo.toFixed(1); 

}


export function convertKBtoGo(sizeKB) {
  const units = ['octets', 'Ko', 'Mo', 'Go'];
  let sizeValue = sizeKB;

  let unitIndex = 0;
  while (sizeValue >= 1024 && unitIndex < units.length - 1) {
    sizeValue /= 1024;
    unitIndex++;
  }

  const formattedSize = sizeValue < 1 ? sizeValue.toFixed(3) : sizeValue.toFixed(0);
  const unit = units[unitIndex];

  return `${formattedSize} ${unit}`;

}

  